export enum PPBText {
  PROJECTNAME = '',
}
